'use strict';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
        if (icon.hasClass('heart-white')) {
            icon.removeClass('heart-white').css('color', '#E23A29');
        }
        if (icon.hasClass('heart-pdp-set')) {
            icon.toggleClass('fa-heart-o wishlist-icon fa-heart heart-white');
        }
    } else {
        status = 'alert-danger';
    }

    $('.add-to-wishlist-messages').html('');
    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

/**
 * Makes an ajax call to add a product to the wishlist
 * @param {string} url - url to hit
 * @param {string} pid - product id
 * @param {string} optionId - product option id
 * @param {string} optionVal - product option value
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 * @param {boolean} login - true if user is adding to wishlist after login
 */
function ajaxAddToWishlist(url, pid, optionId, optionVal, icon, login) {
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal,
            login: login || false
        },
        success: function (data) {
            if (data.searchImpressionData) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(JSON.parse(data.searchImpressionData));
            }
            if (data.removed) {
                icon.addClass('heart-white');
                return;
            }
            displayMessageAndChangeIcon(data, icon);
            if (login) {
                // when users login carousels are loaded, check if the product is in the carousel and change icon
                setTimeout(function () {
                    let iconInCarousel = $(document).find(".einstein-carousel").find(".product[data-pid="+pid+"] .wishlistTile i");
                    if (iconInCarousel.length) {
                        iconInCarousel.removeClass('heart-white').css('color', '#E23A29');
                    }
                }, 2000);
            }
        },
        error: function (err) {
            if (err.status === 500 && err.responseJSON.loggedin === false) {
                // if user is not logged in, save the pid and options to local storage to add to wishlist after login
                var addToWishlistData = {
                    url: url,
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                };
                localStorage.setItem('favoritePid', JSON.stringify(addToWishlistData));
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                displayMessageAndChangeIcon(err, icon);
            }
        }
    });
}

$('body').on('add-to-wishlist', function (e, url, pid, optionId, optionVal, login) {
    // trigger event to add to wishlist after login
    let icon =$(document).find(".product[data-pid="+pid+"] .wishlistTile i");
    let setItem = $(document).find(".set-item[data-pid="+pid+"]");
    if (!icon.length && setItem.length) {
        icon = setItem.find(".add-to-wish-list").find("i");
    }
    setTimeout(function() {
        ajaxAddToWishlist(url, pid, optionId, optionVal, icon, login);
    }, 300);
});

let addToWishlist = localStorage.getItem('addToWishlist');
if (addToWishlist) {
    // Add to wishlist after login if user was not logged in
    addToWishlist = JSON.parse(addToWishlist);
    $('body').trigger('add-to-wishlist', [addToWishlist.url, addToWishlist.pid, addToWishlist.optionId, addToWishlist.optionVal, true]);
    localStorage.removeItem('addToWishlist');
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', function (e) {
            e.preventDefault();
            var icon = $(this).find($('i'));
            var url = $(this).attr('href');
            var pid = $(this).closest('.product').data('pid');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }
            ajaxAddToWishlist(url, pid, optionId, optionVal, icon);            
        });
    }
};